// VISINVOKE Books Explorer public product page. Prepared ahead of release and kept NON-PUBLIC: until the
// owner release gate opens the public_product_page surface this route renders a plain not-available page
// marked noindex, and the page is excluded from sitemaps. Releasing needs no portal rebuild.
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { surfaceOpen, useOpenDataReleaseState } from './config/openDataRelease';

function useRobots(content) {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    let tag = document.querySelector('meta[name="robots"]');
    const created = !tag;
    if (!tag) { tag = document.createElement('meta'); tag.setAttribute('name', 'robots'); document.head.appendChild(tag); }
    const previous = tag.getAttribute('content');
    tag.setAttribute('content', content);
    return () => { if (created) tag.remove(); else if (previous !== null) tag.setAttribute('content', previous); };
  }, [content]);
}

export default function BookExplorerPublicPage() {
  const release = useOpenDataReleaseState();
  const live = surfaceOpen(release, 'book-explorer', 'public_product_page');
  useRobots(live ? 'index,follow' : 'noindex,nofollow');
  if (!live) {
    return <main style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', color: '#e2e8f0', padding: 24, textAlign: 'center' }}>
      <div><h1 style={{ fontSize: 28 }}>Page not available</h1><p><Link to="/" style={{ color: '#f5e6c8' }}>Return to VISINVOKE</Link></p></div>
    </main>;
  }
  return <main style={{ maxWidth: 1080, margin: '0 auto', padding: '48px 20px', color: '#f6f3ec' }}>
    <p style={{ letterSpacing: '.16em', fontSize: 12, color: '#a9a6c2' }}>FREE VISINVOKE UTILITY</p>
    <h1 style={{ fontSize: 44, margin: '8px 0' }}>VISINVOKE Books Explorer</h1>
    <p style={{ fontSize: 19, color: '#d9d4ff', maxWidth: 760 }}>Explore books, authors, editions and ISBNs in one fast, clean, ad-free Explorer. Every answer comes from the VISINVOKE book catalogue.</p>
    <ul style={{ lineHeight: 1.9 }}>
      <li>Search titles, authors and ISBN-10 or ISBN-13 numbers</li>
      <li>See every catalogued edition of a book, with publishers, languages, formats and identifiers</li>
      <li>Compare editions field by field</li>
      <li>Author bibliographies ordered by first publication</li>
      <li>Private shelves, ratings, notes, lists and reading goals on your own device</li>
    </ul>
    <p style={{ color: '#a9a6c2' }}>Runs in the VISINVOKE Desktop Command Center on Windows and Android. Bibliographic data: Open Library (Internet Archive), served entirely by VISINVOKE.</p>
  </main>;
}
